export enum HeaderLogoBlock {
  Root = 'HeaderLogo',
}

export enum HeaderLogoElement {
  View = 'view',
  Print = 'print',
}
